import { z } from "zod";
export const FontSetIdSchema = z.union([
    z.literal("modern"),
    z.literal("retro"),
    z.literal("elegant"),
    z.literal("friendly"),
    z.literal("creative"),
    z.literal("clarity"),
    z.literal("casual"),
    z.literal("boho-chic"),
    z.literal("retro-vibes"),
    z.literal("handcraft-studio"),
    z.literal("beach-house"),
    z.literal("coffee-shop"),
    z.literal("art-studio"),
    z.literal("garden-party"),
    z.literal("indie-maker"),
    z.literal("creative-freelancer"),
    z.literal("cozy-cafe"),
    z.literal("startup-hustle"),
    z.literal("mystic-moon"),
    z.literal("urban-street"),
    z.literal("vintage-typewriter"),
    z.literal("digital-nomad"),
    z.literal("artisan-craft"),
    z.literal("festival-vibes"),
    z.literal("nordic-minimal"),
    z.literal("tropical-paradise"),
    z.literal("tech-startup"),
]);
export const FontLabel = {
    "inter": "Inter",
    "playfair": "Playfair Display",
    "merriweather-sans": "Merriweather Sans",
    "vt323": "VT323",
    "roboto": "Roboto",
    "nunito": "Nunito",
    "bricolage-grotesque": "Bricolage Grotesque",
    "lato": "Lato",
    "dm-sans": "DM Sans",
    "merriweather": "Merriweather",
    "satisfy": "Satisfy",
    "comfortaa": "Comfortaa",
    "kalam": "Kalam",
    "righteous": "Righteous",
    "open-sans": "Open Sans",
    "caveat": "Caveat",
    "poppins": "Poppins",
    "quicksand": "Quicksand",
    "dancing-script": "Dancing Script",
    "pacifico": "Pacifico",
    "source-sans-pro": "Source Sans Pro",
    "fredoka-one": "Fredoka One",
    "work-sans": "Work Sans",
    "amatic-sc": "Amatic SC",
    "raleway": "Raleway",
    "rubik": "Rubik",
    "inconsolata": "Inconsolata",
    "montserrat": "Montserrat",
    "shadows-into-light": "Shadows Into Light",
    "ubuntu": "Ubuntu",
    "cookie": "Cookie",
    "space-mono": "Space Mono",
    "oswald": "Oswald",
    "crimson-text": "Crimson Text",
    "fira-sans": "Fira Sans",
    "abril-fatface": "Abril Fatface",
    "lobster": "Lobster",
    "jetbrains-mono": "JetBrains Mono",
    "permanent-marker": "Permanent Marker",
    "pt-serif": "PT Serif",
};
// Pro font sets - all the new creative font sets require Pro subscription
export const ProFontSets = [
    "boho-chic",
    "retro-vibes",
    "handcraft-studio",
    "beach-house",
    "coffee-shop",
    "art-studio",
    "garden-party",
    "indie-maker",
    "creative-freelancer",
    "cozy-cafe",
    "startup-hustle",
    "mystic-moon",
    "urban-street",
    "vintage-typewriter",
    "digital-nomad",
    "artisan-craft",
    "festival-vibes",
    "nordic-minimal",
    "tropical-paradise",
    "tech-startup",
];
export const FontSet = {
    modern: {
        heading: "inter font-bold",
        subheading: "inter",
        body: "inter",
    },
    retro: {
        heading: "vt323",
        subheading: "roboto",
        body: "roboto",
    },
    elegant: {
        heading: "playfair font-bold",
        subheading: "merriweather-sans",
        body: "merriweather-sans",
    },
    friendly: {
        heading: "nunito font-bold",
        subheading: "nunito",
        body: "nunito",
    },
    creative: {
        heading: "bricolage-grotesque font-bold",
        subheading: "lato",
        body: "lato",
    },
    clarity: {
        heading: "dm-sans",
        subheading: "merriweather",
        body: "merriweather",
    },
    casual: {
        heading: "satisfy",
        subheading: "roboto",
        body: "roboto",
    },
    "boho-chic": {
        heading: "comfortaa font-bold",
        subheading: "kalam",
        body: "kalam",
    },
    "retro-vibes": {
        heading: "righteous",
        subheading: "open-sans",
        body: "open-sans",
    },
    "handcraft-studio": {
        heading: "caveat font-bold",
        subheading: "poppins",
        body: "poppins",
    },
    "beach-house": {
        heading: "dancing-script font-bold",
        subheading: "quicksand",
        body: "quicksand",
    },
    "coffee-shop": {
        heading: "pacifico",
        subheading: "source-sans-pro",
        body: "source-sans-pro",
    },
    "art-studio": {
        heading: "fredoka-one",
        subheading: "work-sans",
        body: "work-sans",
    },
    "garden-party": {
        heading: "amatic-sc font-bold",
        subheading: "raleway",
        body: "raleway",
    },
    "indie-maker": {
        heading: "rubik font-bold",
        subheading: "inconsolata",
        body: "inconsolata",
    },
    "creative-freelancer": {
        heading: "shadows-into-light",
        subheading: "montserrat",
        body: "montserrat",
    },
    "cozy-cafe": {
        heading: "cookie",
        subheading: "ubuntu",
        body: "ubuntu",
    },
    "startup-hustle": {
        heading: "space-mono font-bold",
        subheading: "inter",
        body: "inter",
    },
    "mystic-moon": {
        heading: "dancing-script font-bold",
        subheading: "crimson-text",
        body: "crimson-text",
    },
    "urban-street": {
        heading: "oswald font-bold",
        subheading: "fira-sans",
        body: "fira-sans",
    },
    "vintage-typewriter": {
        heading: "abril-fatface",
        subheading: "pt-serif",
        body: "pt-serif",
    },
    "digital-nomad": {
        heading: "jetbrains-mono font-bold",
        subheading: "rubik",
        body: "rubik",
    },
    "artisan-craft": {
        heading: "lobster",
        subheading: "merriweather-sans",
        body: "merriweather-sans",
    },
    "festival-vibes": {
        heading: "permanent-marker",
        subheading: "quicksand",
        body: "quicksand",
    },
    "nordic-minimal": {
        heading: "lato font-bold",
        subheading: "source-sans-pro",
        body: "source-sans-pro",
    },
    "tropical-paradise": {
        heading: "pacifico",
        subheading: "nunito",
        body: "nunito",
    },
    "tech-startup": {
        heading: "montserrat font-bold",
        subheading: "dm-sans",
        body: "dm-sans",
    },
};
